import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-event-note',
  templateUrl: 'event-note.html'
})
export class EventNotePage {

  noteData: any;
  event: any;

  /**
   * Page detail note
   * @description: TODO
   *
   * @param navCtrl
   * @param params
   */
  constructor(public navCtrl: NavController, public params: NavParams) {
    this.noteData = this.params.get('note');
    this.event = this.params.get('event');
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-note/event-note.ts